import imagePickerView from './imagePickerComponent.html';
import './imagePickerComponent.css';

export function imagePickerComponent() {
	return {
		bindings: {
			model: '=',
			onChange: '&',
			imageChoices: '=',
		},
		controllerAs: 'vm',
		controller: imagePickerComponentCtrl,
		template: imagePickerView,
	};
}

export class imagePickerComponentCtrl {
	constructor(Api, $timeout, $scope, Cfg, Identity) {
		'ngInject';
		this.Api = Api;
		this.$timeout = $timeout;
		this.$scope = $scope;
		this.Cfg = Cfg;
		this.Identity = Identity;
	}

	$onInit() {
		this.allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];

		this.$scope.$watch('vm.model', this.onChange);
		this.myImages = [];

		this.tabIsClosed = {
			web: this.Cfg.readAsBool('UI.post_image_tab_web') === false,
			royaltyFree: this.Cfg.readAsBool('UI.post_image_tab_royalty_free') === false,
			upload: this.Cfg.readAsBool('UI.post_image_tab_upload') === false,
			paste: this.Cfg.readAsBool('UI.post_image_tab_paste') === false,
			library: this.Cfg.readAsBool('UI.post_image_tab_image_library') === false,
		};
		this.defaultTab = this.Cfg.read('UI.post_image_tab_default');

		// calculate the hidden tabs
		const tabSetting = this.Cfg.read('UI.visible_post_image_tabs');
		this.tabIsHidden = {
			web: true,
			royalty_free: true,
			upload: true,
			paste: true,
			image_library: true,
		};

		if (tabSetting) {
			tabSetting.split(',').forEach(visibleTab => {
				this.tabIsHidden[visibleTab.trim()] = false;
			});
		}

		const accountId = this.Identity.currentAffiliationId();
		const hubId = this.Identity.currentClient().id;
		const imageLibraryUrl = `/v4/accounts/${accountId}/hubs/${hubId}/image-library`;

		this.Api.get(imageLibraryUrl).then(({ payload }) => {
			this.imageLibrary = payload.map(i => {
				return { url: i.filename };
			});
		});
	}

	uploadMyOwn() {
		// <sh-upload> uses "href" but post edit page uses "url"
		this.myImages[0].url = this.myImages[0].href;
		this.model = this.myImages[0];
	}

	webSearch(term) {
		this.webResults = [];
		this.Api.get('/images/web', { term }).then(data => {
			this.webResults = data;
		});
	}

	freeSearch(term) {
		this.freeResults = [];
		this.Api.get('/images/free', { term }).then(data => {
			this.freeResults = data;
		});
	}

	fetchPasted(url) {
		if (!url.match(/^https?:\/\/.+\..+\/.+/)) {
			this.fetchError = 'Please enter a valid URL.';
			return;
		}
		this.fetchingPastedUrl = true;
		const image = angular.element(new Image());
		image.on('load', () => {
			const result = {
				thumbnail: url,
				url: url,
				height: image[0].height,
				width: image[0].width,
			};
			this.model = result;
			this.fetchError = '';
			this.fetchingPastedUrl = false;
			this.pastedImages = [result];
			this.$timeout(() => {});
		});
		image.on('error', () => {
			this.fetchingPastedUrl = false;
			this.fetchError = 'Error fetching image from that URL.';
			this.$timeout(() => {});
		});
		image.prop('src', url);
	}

	useNone() {
		// This will remove all images in the carousel
		this.model = false;
		if (typeof this.imageChoices !== 'undefined') {
			this.imageChoices.length = 0;
		}
	}
}
